import { render, staticRenderFns } from "./communityActivitiesDetail.vue?vue&type=template&id=e6534c88&scoped=true"
import script from "./communityActivitiesDetail.vue?vue&type=script&lang=js"
export * from "./communityActivitiesDetail.vue?vue&type=script&lang=js"
import style0 from "./communityActivitiesDetail.vue?vue&type=style&index=0&id=e6534c88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6534c88",
  null
  
)

export default component.exports